import style from "../../../../assets/scss/common/modal/addConsultationModal.module.scss";
import React from "react";
import {useTranslation} from "react-i18next";

interface Args {
    childName: string;
    testInfo: string;
}

export function ReservationProfileInfo({childName, testInfo}: Args) {
    /**
     * 프로필(자녀) 정보 확인 영역
     */
    const { t } = useTranslation("consultant");
    return (
        <div className={style.innerTextContainer}>
            <div className={style.infoContainer}>
                <span className={style.infoTitleText}> {t('detail.modal.profileInfo')}</span>
                <span className={style.infoText}>{t('detail.modal.name')}</span>
                <input
                    placeholder="아이이름1"
                    className={style.inputField}
                    value={childName}
                    disabled={true}
                />
                <span className={style.infoText}>{t('detail.modal.testType')}</span>
                <input
                    placeholder={t('detail.modal.testRoundPlaceholder')}
                    className={style.inputField}
                    value={testInfo}
                    disabled={true}
                />
            </div>
        </div>

    )
}